import { FilterPreferenceRecognizedLists } from '../../../../../services/modules/userContextPreferences/userContextPreferences.types';
import useCatalogListSearchField from '../../../filter/useCatalogListSearchField';
import { CatalogListFiltersProviderProps } from '../catalogListPage.types';

const CatalogListPageOfflineFilters = ({ children }: CatalogListFiltersProviderProps) => {
  const { searchField, isSearchActive, onClearSearch } = useCatalogListSearchField({
    shouldIgnoreDefaultFilters: true,
  });

  return children({
    options: [],
    preferenceList: FilterPreferenceRecognizedLists.CATALOGS,
    columnsVisibility: null,
    searchField,
    isSearchActive,
    onClearSearch,
  });
};

export default CatalogListPageOfflineFilters;
